<template>
  <model-import model="device">
      <template #form="form">

        <b-row>
                <b-col md="12">
                  <b-form-group :label="$t('Owner')">
                    <v-select
                      :disabled=form.disabled
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      v-model="form.request.ownerId"
                      label="name" 
                      :reduce="owner => owner.id"
                      :options="ownerOptions" 
                      class="w-100"
                    />
                    <small v-if="('ownerId' in form.errors)" class="text-danger">
                        {{ $t(form.errors['ownerId'][0]) }}
                    </small>
                  </b-form-group>
                </b-col>
        </b-row>

        <b-row>
                <b-col md="12">
                  <b-form-group :label="$t('Contract')">
                    <v-select
                      :disabled=form.disabled
                      :dir="$store.getters['auth/preferDirIsRtl'] ? 'rtl' : 'ltr'"
                      v-model="form.request.contractId"
                      label="name" 
                      :reduce="contract => contract.id"
                      :options="contractOptions" 
                      class="w-100"
                    />
                    <small v-if="('contractId' in form.errors)" class="text-danger">
                        {{ $t(form.errors['contractId'][0]) }}
                    </small>
                  </b-form-group>
                </b-col>
        </b-row>

      </template>

    </model-import>
</template>

<script>

import vSelect from 'vue-select'
import { ref } from '@vue/composition-api'
import { 
  BCol, 
  BFormGroup,  
  BRow, 
} from 'bootstrap-vue'
import axios from '@axios'
import store from '@/store';
import ModelImport from '@/views/modules/Utils/ModelImport.vue';


export default {

  name: 'ImportContainer',
  components: { 
    vSelect,
    BRow, 
    BCol, 
    BFormGroup, 
    ModelImport
  },
  setup(props, {root}) {

    const getOptions = (type) => {
      return new Promise((resolve, reject) => {
        axios.get('/userGetLinked', {params:{
        user:store.state.auth.userData.id,
        type:type
        }})
        .then((res) => {
          resolve(res.data.data)
        })
        .catch((e) => {
          console.log(e.response)
        })
      })
    }

    const ownerOptions = ref([])
    const contractOptions = ref([])

    getOptions('user').then((data) => ownerOptions.value = data)
    getOptions('contract').then((data) => contractOptions.value = data)

    return {
      ownerOptions,
      contractOptions
    }

  }
}
</script>

<style scoped>

</style>
